import comp from "/home/runner/work/dialtone/dialtone/apps/dialtone-documentation/docs/.vuepress/.temp/pages/404.html.vue"
const data = JSON.parse("{\"path\":\"/404.html\",\"title\":\"\",\"lang\":\"en-US\",\"frontmatter\":{\"layout\":\"NotFound\"},\"git\":{},\"headers\":[]}")
export { comp, data }
